import { Dashboardv99990101CommonModels } from '@sequencehq/api/dist/clients/dashboard/v99990101'

export type FieldMetadata =
  Dashboardv99990101CommonModels.Contract.FieldMetadata

export type FieldMetadataStatus =
  Dashboardv99990101CommonModels.Contract.FieldMetadataStatus

export type ContractPage = Dashboardv99990101CommonModels.Contract.ContractPage

export const Model = {
  GEMINI_2_0_FLASH_001: 'GEMINI_2_0_FLASH_001',
  GEMINI_2_0_FLASH_LITE_001: 'GEMINI_2_0_FLASH_LITE_001'
} as const

export type Model = (typeof Model)[keyof typeof Model]
